import React, { useState, useCallback, useEffect } from "react";
import DashMenu from "../../part/dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import { useParams } from "react-router-dom";
import Image1 from "../../image/tope.jpg";
import DescribeBody from "../../part/user/description.body";
import DescribeCourse from "../../part/user/course_description";
import RelatedVideo from "../../part/user/related_videos";
import CourseVideo from "../../part/user/course_video";
import DocumentCourse from "../../part/user/course_description_document";
import IncludeCourse from "../../part/user/course.include";
import CourseProcedure from "../../part/user/course.procedure";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import CourseReview from "../../part/user/course.review";
import AssignmentCourse from "../../part/user/course_assignment";
import AddAssignment from "../../part/user/add.assignment";
import AddReview from "../../part/user/add.review";
import ApplyProfileForm from "../../part/user/apply_profile";
import LoadingError from "../../part/loading_error";
import NetworkIssue from "../../part/network";
import MapComponent from "../../part/location.map";
import axios from "axios";
import { IoMdLock } from "react-icons/io";
import UserExamSection from "../../part/user/user_exam_list";
import CourseSchema from "../CourseSchema";

const CourseDescription = () => {
  const getInitialMenuCoverWidth = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 900) return 0;
    if (windowWidth >= 900 && windowWidth < 1200) return 60;
    return 260;
  };

  const [documentsNeedRefresh, setDocumentsNeedRefresh] = useState(false);
  const [menuCoverWidth, setMenuCoverWidth] = useState(getInitialMenuCoverWidth());
  const { course_id, course_name } = useParams();
  const [loading, setLoading] = useState(true);
  const [network, setNetwork] = useState(false);
  const [section, setSection] = useState("overview");
  const [courses, setCourses] = useState([]);

  // 🔹 Error popup state
  // const [showError, setShowError] = useState(false);
  // const errorTimerRef = useRef(null);

  const fetchData = useCallback(async () => {
    const courseId = parseInt(course_id, 10);
    const accessToken = localStorage.getItem("accessToken");

    try {
      const response = await axios.get(
        `https://api.geoinfoacademy.com/api/courses/${courseId}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      setCourses(response.data);
      setLoading(false);
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");
        window.location.href = "/";
      } else if (error.code === "ERR_NETWORK") {
        setNetwork(true);
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  }, [course_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleResize = useCallback(() => {
    const menuCover = document.querySelector(".dashboard .menu_cover");
    if (menuCover) {
      setMenuCoverWidth(menuCover.offsetWidth);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  const handleSectionChange = (value) => {
    setSection(value);
  };

  // 🔹 Locked material click
  // const handleLockedClick = () => {
  //   setShowError(true);

  //   // clear any existing timer before starting a new one
  //   if (errorTimerRef.current) {
  //     clearTimeout(errorTimerRef.current);
  //   }

  //   errorTimerRef.current = setTimeout(() => {
  //     setShowError(false);
  //     errorTimerRef.current = null;
  //   }, 4000);
  // };

  // // 🔹 Cleanup timeout on unmount
  // useEffect(() => {
  //   return () => {
  //     if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
  //   };
  // }, []);

  return (
    <div className="dashboard">
      <DashSearchHeader onResize={handleResize} />
      <DashMenu />
      <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }}>
        <DescribeBody course_id={course_id} course={courses} fetchcourse={fetchData} />

        <div className="description_information">
          <nav className="description_filter">
            <button
              className={section === "overview" ? "active" : null}
              onClick={() => handleSectionChange("overview")}
            >
              Overview
            </button>

            <button
              className={section === "material" ? "active" : null}
              onClick={() => handleSectionChange("material")}
            // courses.enrolled ? 

            //  : handleLockedClick

            >
              Training Materials{" "}
              {courses.enrolled ? null : <IoMdLock style={{ marginLeft: "10px" }} />}
            </button>
          </nav>

          {section === "overview" && (
            <>
              <DescribeCourse course_id={course_id} course={courses} />
              <CourseProcedure course_id={course_id} course={courses} />

              <IncludeCourse course_id={course_id} course={courses} />
              {courses.training_type !== "Online Prerecorded" &&
                courses.training_type !== "Online Live with Facilitator" ? (
                <section className="descript_include" style={{ marginTop: "30px" }}>
                  <MapComponent />
                </section>
              ) : null}
              <CourseReview
                course_id={course_id}
                course={courses}
                shouldRefresh={documentsNeedRefresh}
                onRefreshDone={() => setDocumentsNeedRefresh(false)}
              />
              <RelatedVideo course_id={course_id} course={courses} />

              <section className="course_instructor">
                <h3>Instructor</h3>
                <div className="image">
                  <img src={Image1} alt="CEO" />
                </div>
                <div className="about">
                  <h4>
                    Mr Tope <br />
                    <span>CEO at Geoinfotech</span>{" "}
                  </h4>
                </div>
              </section>
            </>
          )}

          {section === "material" && (
            <>
              <CourseVideo course_id={course_id} course={courses} />
              <DocumentCourse course_id={course_id} course={courses} />
              <AssignmentCourse
                course_id={course_id}
                shouldRefresh={documentsNeedRefresh}
                onRefreshDone={() => setDocumentsNeedRefresh(false)}
              />
              <UserExamSection course_id={course_id} course={courses} course_name={course_name} />

            </>
          )}
        </div>

        <FooterDashboard />
        <Policy onResize={menuCoverWidth} />
        <ApplyProfileForm onResize={menuCoverWidth} course_id={course_id} />
        <AddAssignment course_id={course_id} onRefresh={() => setDocumentsNeedRefresh(true)} />
        <AddReview course_id={course_id} onRefresh={() => setDocumentsNeedRefresh(true)} />
      </div>

      {/* 🔹 Error Popup */}
      {/* {showError && (
        <div className="error-popup">You must enroll in this course to access materials.</div>
      )} */}

      {loading ? <LoadingError /> : null}
      {network ? <NetworkIssue /> : null}
      {!loading && courses.title && (
        <CourseSchema
          name={courses.title}
          description={courses.description}
          url={`https://geoinfoacademy.com/description/${courses.id}/${courses.title}`}
        />
      )}
    </div>
  );
};

export default CourseDescription;
